export default __webpack_public_path__ + "static/media/eicon_atom_circ_logo.a171b021.svg";